import * as Sentry from '@sentry/node'
import getConfig from 'next/config'
import { Integrations } from '@sentry/tracing'
import { CaptureConsole } from '@sentry/integrations'

const isBrowser = () => process.browser

let initialize = false
export function initSentry() {
  if (initialize) return
  initialize = true
  const config = getConfig().publicRuntimeConfig
  const sentryDsn = isBrowser() ? config.sentryDsn : process.env.Sentry__Dsn
  const sentryEnvironment = isBrowser() ? config.env : process.env.env
  const buildVersion = isBrowser() ? config.buildVersion : process.env.BUILD_VERSION

  if (sentryDsn) {
    const integrations = [
      new Integrations.BrowserTracing(),
      new CaptureConsole({
        levels: ['error', 'warn']
      })
    ]
    Sentry.init({
      ignoreErrors: [
        /^\[Meta Pixel\] - Invalid PixelID: null.$/,
        /^\[Facebook Pixel\] - Invalid PixelID.*$/,
        /^\[Meta Pixel\] - Pixel.*not found$/,
        /^\[Facebook Pixel\] - Pixel .* not found$/,
        /^Client input error.*$/,
        /^LogRocket has already been loaded, loading a second instance is not supported.$/,
        /^LogRocket filter manager is using too much memory. Disabling.$/,
        /^Failed to load Stripe.js$/,
        /^TypeError.*$/,
        /^LogRocket.*$/,
        /^Error: AbortError*$/
      ],
      integrations,
      dsn: sentryDsn,
      environment: sentryEnvironment,
      release: buildVersion
    })
  }
}
